import {
  Container,
  Link,
  Stack,
  Typography,
} from '@mui/material'

import { LogoNoISO } from 'lib/components/CustomIcons'

function Footer() {
  const today = new Date()
  const year = today.getFullYear()

  return (
    <Container
      component="footer"
      disableGutters
      maxWidth={false}
      sx={{ py: 5, marginTop: 'auto' }}
    >
        <Typography gutterBottom textAlign="center">
          &copy; {year} &ensp;
          <Link href="#main" underline="none">
            <LogoNoISO />
          </Link>
        </Typography>
        <Typography gutterBottom variant="body2" textAlign="center" >
          All rights reserved.
        </Typography>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
        >
          <Link href="/terms-of-service" underline="hover" variant="body2">
            Terms of Service
          </Link>
          <Link href="/privacy-policy" underline="hover" variant="body2">
            Privacy Policy
          </Link>
          <Link href="/licenses" underline="hover" variant="body2">
            Licenses
          </Link>
        </Stack>
    </Container>
  )
}

export default Footer
